var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "cargo-advance-select",
        _vm._b(
          {
            attrs: {
              disabled: true,
              "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
              "default-value": _vm.cargoDoc.dischargingPortCode,
              "tag-name": "englishName"
            }
          },
          "cargo-advance-select",
          _vm.$attrs,
          false
        )
      ),
      _c("el-input", {
        staticStyle: { "margin-top": "5px" },
        on: {
          change: function($event) {
            return _vm.onChange("dischargingPort")
          }
        },
        model: {
          value: _vm.cargoDoc.dischargingPort,
          callback: function($$v) {
            _vm.$set(_vm.cargoDoc, "dischargingPort", $$v)
          },
          expression: "cargoDoc.dischargingPort"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }